import { PageNumberBasedListRequest, PageNumberBasedListResponse } from "@/features/types";
import useFetcher from "@/utils/use-fetcher";
import useSWR, { SWRConfiguration } from "swr";
import { Identity } from "@/features/ui/hooks/use-identity";
import { toIdentityParameter } from "@/features/ui/helpers/identity-helpers";

export interface ListProductImagesRequest extends PageNumberBasedListRequest {
  lineSheetProductId?: number;
}

export interface ListProductImagesResponse extends PageNumberBasedListResponse {
  productImages: {
    id: number;
    searchWord: string;
    lineSheetProductSkuId: number;
    skuIsValid: boolean;
    images: {
      id: number;
      url: string;
      reviewStatus: string;
      type: string;
      isOriginal: boolean;
    }[]
  }[]
}

export interface ListProductImagesPathParameter {}

export function getListProductImagesParameter(
  identity: Identity | null
): ListProductImagesPathParameter | null {
  return toIdentityParameter(identity);
}

export function getListProductImagesKey(
  request?: ListProductImagesRequest
) {
    return {
      url: "/product/images",
      params: {
        ...request,
        sku__is_exists: true,
      },
    };
  }

export default function useListProductImages(
  request?: ListProductImagesRequest,
  config?: SWRConfiguration
) {
  const fetcher = useFetcher<
    ListProductImagesRequest,
    ListProductImagesResponse
  >();

  const { mutate, ...rest } = useSWR(
    getListProductImagesKey(request),
    fetcher,
    config
  );

  return {
    mutate,
    ...rest,
  };
}
